import { apiToken, validatePromoCodeUrl } from "../config";

export const validatePromoCode = async (promoCode) => {
    try {
        const response = await fetch(`${validatePromoCodeUrl}${promoCode}`,{
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${apiToken}` 
            }
        });
        const res =  await response.json();
        if (!response.ok) {
            throw new Error(res.message || "Failed to fetch data");
        }
        return res;
        
    } catch(e) {
        throw new Error(e.message || 'Failed to validate promo code');
    }
}